import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import AdminCourses from '../../components/views/admin/Courses'
import CourseEditor from '../../components/views/admin/Courses/CourseEditor'

/*
 * Kursverwaltung — nur die Bundesverwaltung. Was hier geändert wird, sehen
 * die Schüler:innen aller Bundesländer; die Landesbetreuung sieht die
 * Auswertung, pflegt aber keine Inhalte.
 */
function CoursesAdminPage(props) {
	if (props.role !== TRoles.FEDERAL_ADMIN) return <Redirect to={TRoutes.DASHBOARD} />
	return <AdminCourses />
}

CoursesAdminPage.propTypes = { role: PropTypes.string.isRequired }

function CourseEditorPage(props) {
	if (props.role !== TRoles.FEDERAL_ADMIN) return <Redirect to={TRoutes.DASHBOARD} />
	return <CourseEditor />
}

CourseEditorPage.propTypes = { role: PropTypes.string.isRequired }

export const AdminCoursesPage = injectRole(CoursesAdminPage)
export const AdminCourseEditorPage = injectRole(CourseEditorPage)
